import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMobileMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={closeMobileMenu}>
          <img src={logo} alt="Segovia BBQ Cookoff" />
        </Link>
      </div>
      
      
      <ul className="navbar-links desktop-menu">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/details">Event Details</Link></li>
        <li><Link to="/kids-cookoff">Kids Cookoff</Link></li>
        <li><Link to="/sponsors">Sponsors</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/register" className="cta-button">Register</Link></li>
      </ul>

      
      <button 
        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}

      
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <img src={logo} alt="Segovia BBQ Cookoff" className="mobile-logo" />
          <button className="close-button" onClick={closeMobileMenu}>
            <span>&times;</span>
          </button>
        </div>
        <ul className="mobile-menu-links">
          <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
          <li><Link to="/details" onClick={closeMobileMenu}>Event Details</Link></li>
          <li><Link to="/kids-cookoff" onClick={closeMobileMenu}>Kids Cookoff</Link></li>
          <li><Link to="/sponsors" onClick={closeMobileMenu}>Sponsors</Link></li>
          <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
          <li><Link to="/register" className="mobile-cta-button" onClick={closeMobileMenu}>Register</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 